import React from 'react';
import CloneORRIDialog from 'src/components/project/sections/TractComponents/dialogs/CloneORRIDialog';
import DeleteORRIDialog from '../../components/project/sections/TractComponents/dialogs/DeleteORRIDialog';
import WIOwnership from '../../models/tract_detail/WIOwnership';
import Owner from 'src/models/tract_detail/Owner';
import ManageLeaseholdDialog2 from 'src/components/project/sections/TractComponents/ManageLeaseholdDialog.redesign';
import CloneDataDialog from 'src/components/dialogs/CloneDataDialog';
import DeleteOwnershipDialog from 'src/components/project/sections/TractComponents/DeleteOwnershipDialog';

export type dialogCreator = {
    cloneORRI: (targetWorkingInterestId: number, targetWIName: string, onComplete: () => void) => void;
    deleteORRI: (workingInterestId: number, workingInterestName: string, orriList: WIOwnership[], ownerList: Owner[], onComplete: () => void) => void;
    manageLeaseholds: (ownershipId: number, horizonNumber: number, navigate: (path: string) => void) => void;
    // tslint:disable-next-line:max-line-length
    copyOwnership: (context: 'ownership' | 'surfaceOwnership' | 'workingInterest', contextParams: { [key: string]: number | string }, cloneData: (context: string, options: string) => void) => void;
    deleteOwnership: (ownershipId: number, navigate: (path: string) => void, confirmDelete: () => void) => void;
};

const creators = (setDialog: (element: React.ReactElement) => void): dialogCreator => {
    return {
        cloneORRI: (targetWorkingInterestId: number, targetWorkingInterestName: string, onComplete: () => void) => {
            setDialog(
                React.createElement(CloneORRIDialog, {
                    targetWorkingInterestId,
                    targetWorkingInterestName,
                    onComplete,
                })
            );
        },
        deleteORRI: (workingInterestId: number, workingInterestName: string, orriList: WIOwnership[], ownerList: Owner[], onComplete: () => void) => {
            setDialog(
                React.createElement(DeleteORRIDialog, {
                    workingInterestId,
                    workingInterestName,
                    orriList,
                    ownerList,
                    onComplete,
                })
            );
        },
        manageLeaseholds: (ownershipId: number, horizonNumber: number, navigate: (path: string) => void) => {
            setDialog(
                React.createElement(ManageLeaseholdDialog2, {
                    ownershipId,
                    horizonNumber: horizonNumber,
                    navigate
                })
            );
        },
        // tslint:disable-next-line:max-line-length
        copyOwnership: (context: 'ownership' | 'surfaceOwnership' | 'workingInterest', contextParams: { [key: string]: number | string }, cloneData: (context: string, options: string) => void) => {
            setDialog(
                React.createElement(CloneDataDialog, {
                    context: context,
                    contextParams: contextParams,
                    cloneData: cloneData,
                })
            );
        },
        deleteOwnership: (ownershipId: number, navigate: (path: string) => void, confirmDelete: () => void) => {
            setDialog(
                React.createElement(DeleteOwnershipDialog, {
                    ownershipId: ownershipId,
                    navigate: navigate,
                    confirmDelete: confirmDelete,
                })
            );
        }
    };
};

export default creators;


// WEBPACK FOOTER //
// ./src/providers/dialogs/leasehold.ts